export default __webpack_public_path__ + "static/media/Mask of Ben Morgh.1993e795.jpg";